module.exports = __webpack_public_path__ + "static/media/nat-9.ffc5756a.jpg";